module.exports = __webpack_public_path__ + "img/income-and-expense-log_B09K26D6PN.840ec7d9.jpg";